import { isRefundPending, REFUND_CLOSING_SOON_DAYS } from './refundTimeline';

export { REFUND_CLOSING_SOON_DAYS };

const STATUS_LABELS = {
  REJECTED: 'Order Rejected',
  ORDER_FORM_REFILL_REQUEST: 'Order Form Refill Required',
  REFUND_FORM_REFILL_REQUEST: 'Refund Form Refill Required',
  REJECT_AND_REFILL: 'Reject and Refill Refund Form',
  ORDER_FORM_FILLED: 'Refund Form Pending',
};

export const getOrderActionCase = (order) => {
  const status = order.status || order.orderStatus;
  if (status === 'REJECTED') return 'REJECTED';
  if (status === 'ORDER_FORM_REFILL_REQUEST') return 'ORDER_FORM_REFILL_REQUEST';
  if (status === 'REFUND_FORM_REFILL_REQUEST' || status === 'REJECT_AND_REFILL') return 'REFUND_FORM_REFILL_REQUEST';
  if (isRefundPending(status) && order.refundTimeline?.refundFormOpen
      && order.refundTimeline?.daysLeftToClose > 0
      && order.refundTimeline?.daysLeftToClose <= REFUND_CLOSING_SOON_DAYS) {
    return 'REFUND_CLOSING_SOON';
  }
  if (isRefundPending(status) && order.refundTimeline?.refundFormOpen) return 'REFUND_PENDING';
  return null;
};

export const buildOrderWhatsAppMessage = (order) => {
  const orderId = order.orderId || order.id;
  const caseType = getOrderActionCase(order);
  const reason = order.reason?.trim();
  const buyerName = order.customer || order.reviewerName || 'Buyer';

  const lines = [`Hello ${buyerName},`, '', `This is regarding your ZMA order *${orderId}*.`, ''];

  switch (caseType) {
    case 'REJECTED':
      lines.push('Your order has been *rejected*.');
      if (reason) lines.push('', `Reason: ${reason}`);
      lines.push('', 'Please contact us if you need clarification.');
      break;
    case 'ORDER_FORM_REFILL_REQUEST':
      lines.push('Please *refill your order form* with the corrected details.');
      if (reason) lines.push('', `Reason: ${reason}`);
      lines.push('', 'Use the order form link shared with you or visit zmaonline.in/order');
      break;
    case 'REFUND_FORM_REFILL_REQUEST':
      lines.push('Your refund form was *rejected*. Please *refill your refund form* with the corrected details.');
      if (reason) lines.push('', `Reason: ${reason}`);
      lines.push('', `Refund form: zmaonline.in/refund?orderId=${orderId}&refill=true`);
      break;
    case 'REFUND_CLOSING_SOON':
      lines.push(`*Urgent:* Your refund form closes in ${order.refundTimeline.daysLeftToClose} day(s).`);
      lines.push('Please fill it before the deadline to avoid penalties.');
      lines.push('', `Refund form: zmaonline.in/refund?orderId=${orderId}`);
      break;
    case 'REFUND_PENDING':
      lines.push('Your refund form is still pending.');
      if (order.refundTimeline?.daysLeftToClose != null) {
        lines.push(`${order.refundTimeline.daysLeftToClose} day(s) left before the form closes.`);
      }
      lines.push('', `Refund form: zmaonline.in/refund?orderId=${orderId}`);
      break;
    default:
      lines.push(`Current status: ${order.status || order.orderStatus || 'Updated'}.`);
      if (reason) lines.push('', `Note: ${reason}`);
      break;
  }

  lines.push('', '— ZMA Team');
  return lines.join('\n');
};

export const shareWhatsAppToNumber = (number, message) => {
  if (!number) return;
  const cleanNumber = number.replace(/\D/g, '');
  const full = cleanNumber.length === 10 ? `91${cleanNumber}` : cleanNumber;
  const url = message
    ? `https://wa.me/${full}?text=${encodeURIComponent(message)}`
    : `https://wa.me/${full}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};

export const isActionRequiredOrder = (order) => {
  const status = order.status || order.orderStatus;
  if (['REJECTED', 'REJECT_AND_REFILL', 'ORDER_FORM_REFILL_REQUEST', 'REFUND_FORM_REFILL_REQUEST'].includes(status)) {
    return true;
  }
  return getOrderActionCase(order) === 'REFUND_CLOSING_SOON';
};

export { STATUS_LABELS };
